// extracted by mini-css-extract-plugin
export default {"content":"LoggedAs_content__sxqG3","title":"LoggedAs_title__D6oFz","codeInput":"LoggedAs_codeInput__RypuH","codeBox ":"LoggedAs_codeBox __uJGhd","actions":"LoggedAs_actions__sm1KV"};